import {DataServiceBase} from "../DataServiceBase";
import {HttpResult} from "../HttpService";

export class ParticipantConditionsService extends DataServiceBase {
    constructor() {
        super('/SmartAccount/Participant/Conditions');
    }
}